import { type ReactNode } from 'react';
import { useAuth } from '@/hooks/use-auth';
import { useSupportLink } from '@/hooks/use-support-link';
import { ProfileForm } from './profile-form';

function Loading(): ReactNode {
  return (
    <div className="space-y-base">
      <div className="h-7 w-32 animate-pulse rounded bg-surface-elevated" />
      <div className="h-5 w-64 animate-pulse rounded bg-surface-elevated" />
    </div>
  );
}

function Subtitle(): ReactNode {
  const support = useSupportLink();
  return (
    <p className="mt-xs text-sm text-text-secondary">
      Tus datos personales y de contacto. Para cambiar tu contraseña o
      billetera,{' '}
      <a
        href={support ?? '#'}
        target="_blank"
        rel="noopener noreferrer"
        className="text-info hover:underline"
      >
        dirígete a soporte
      </a>
      .
    </p>
  );
}

export function ProfilePage(): ReactNode {
  const { user } = useAuth();
  return (
    <div className="mx-auto w-full max-w-[42rem] space-y-xl px-base py-lg">
      <header>
        <h1 className="font-display text-2xl font-semibold text-text-primary">
          Perfil
        </h1>
        <Subtitle />
      </header>
      {user ? <ProfileForm user={user} /> : <Loading />}
    </div>
  );
}
